import { cn } from '../lib/utils'
import type { FoodChannelId } from '../lib/foodDelivery'
import grabFoodImg from '../assets/food-grabfood.png'
import goFoodImg from '../assets/food-gofood.png'
import shopeeFoodImg from '../assets/food-shopeefood.png'

const FOOD_LOGOS: Record<FoodChannelId, { src: string; alt: string }> = {
  grab: { src: grabFoodImg, alt: 'GrabFood' },
  gofood: { src: goFoodImg, alt: 'GoFood' },
  shopeefood: { src: shopeeFoodImg, alt: 'ShopeeFood' },
}

type Props = {
  channel: FoodChannelId
  className?: string
  /** Tampilkan teks di samping logo (untuk tombol keranjang) */
  showLabel?: boolean
}

function FoodLogoImg({ channel, className }: { channel: FoodChannelId; className?: string }) {
  const { src, alt } = FOOD_LOGOS[channel]
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-[10px] bg-white ring-1 ring-black/[0.08] shadow-sm',
        className ?? 'size-10'
      )}
      title={alt}
    >
      <img
        src={src}
        alt={alt}
        width={64}
        height={64}
        draggable={false}
        className="h-full w-full object-contain select-none p-0.5"
      />
    </span>
  )
}

/** Logo resmi GrabFood / GoFood / ShopeeFood — sama pola dengan ikon marketplace */
export function FoodDeliveryIcon({ channel, className, showLabel = false }: Props) {
  const { alt } = FOOD_LOGOS[channel]

  if (showLabel) {
    return (
      <span className={cn('inline-flex items-center justify-center gap-3', className)}>
        <FoodLogoImg channel={channel} className="size-9" />
        <span className="font-bold text-gray-800">Pesan via {alt}</span>
      </span>
    )
  }

  return <FoodLogoImg channel={channel} className={className} />
}

export function GrabFoodIcon({ className }: { className?: string }) {
  return <FoodDeliveryIcon channel="grab" className={className} />
}

export function GoFoodIcon({ className }: { className?: string }) {
  return <FoodDeliveryIcon channel="gofood" className={className} />
}

export function ShopeeFoodIcon({ className }: { className?: string }) {
  return <FoodDeliveryIcon channel="shopeefood" className={className} />
}
